import { ProductCardsProps } from '../../../types';
import { ProductCardsProps as ComponentProductCardsProps } from '@raisin/components-lib';
import { LocaleKey } from '@raisin/cp-utils';
import { createProductParser } from '../createProductParser';
import { createSectionParser } from '../createSectionParser';
import { getProductLabels, getProductLabelsLegacy } from '../getProductLabels';

export const createProductCardsParser =
  (dependencies: {
    locale: LocaleKey;
    formatMessage;
    linkGenerator: (id: string) => string;
    featureFlags?: {
      isAutoProductLabelEnabled?: boolean;
    };
  }) =>
  ({ description, dbs, sections, header }: ProductCardsProps) => {
    const productParser = createProductParser({
      formatMessage: dependencies.formatMessage,
      locale: dependencies.locale,
      linkGenerator: dependencies.linkGenerator,
      getProductLabels: dependencies.featureFlags?.isAutoProductLabelEnabled
        ? getProductLabels(dependencies.locale)
        : getProductLabelsLegacy(dependencies.locale),
      dbsProducts: dbs,
    });
    const sectionParser = createSectionParser({
      productMapper: productParser,
    });

    return {
      title: header ?? undefined,
      description,
      sections: sections.map(sectionParser),
    } as ComponentProductCardsProps;
  };
